import { readSessionJson, writeSessionJson } from '@/lib/storage';

/**
 * **The hop to `login.` this TAB made, so a second arrival is recognised.**
 *
 * Per-tab `sessionStorage`, not a cookie: the bounce leaves this host and comes
 * back to it, so nothing has to cross hosts — and a cookie would be a new
 * cookie the privacy policy must name in all 22 languages
 * (`worker/privacy.test.ts` caught exactly that). Per tab is also the truer
 * shape: a loop belongs to the tab that is looping, and two tabs no longer
 * brake each other.
 */
const BOUNCE = 'login-bounce';
/** Long enough to cover the hop and the sign-in, short enough not to block a later honest one. */
export const BOUNCE_WINDOW_MS = 2 * 60_000;

export function markBounce(at = Date.now()): void {
  writeSessionJson(null, BOUNCE, at);
}

/**
 * A session reached this host, or the person signed out: whatever hop came before is
 * over (2026-10-30 — the mark used to live out its two minutes after a sign-in, so
 * signing out and opening My raves read as a loop: "Your sign-in did not reach this page").
 */
export function clearBounce(): void {
  writeSessionJson(null, BOUNCE, null);
}

export function bouncedRecently(now = Date.now()): boolean {
  const at = readSessionJson<number | null>(null, BOUNCE, null);
  return typeof at === 'number' && at <= now && now - at < BOUNCE_WINDOW_MS;
}
